import { Edit, Trash2 } from 'lucide-react';

function CostTag({ text }) {
  return <span className="px-2 py-0.5 bg-[#014DB7]/10 text-[#014DB7] rounded text-xs font-medium">{text}</span>;
}

export function CostTable({ costs, categories, fmt, onEdit, onDelete, totalMonthly }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <table className="w-full">
        <thead className="bg-gray-50"><tr>
          <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Name</th>
          <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Category</th>
          <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Tags</th>
          <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Monthly</th>
          <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Actions</th>
        </tr></thead>
        <tbody className="divide-y">
          {costs.map(cost => (
            <CostRow key={cost.id} cost={cost} categories={categories} fmt={fmt} onEdit={onEdit} onDelete={onDelete} />
          ))}
        </tbody>
        <tfoot className="bg-gray-50 border-t-2"><tr>
          <td colSpan={3} className="px-6 py-4 font-bold text-[#0A1628]">Total Monthly</td>
          <td className="px-6 py-4 text-right font-bold text-xl text-[#014DB7]">{fmt(totalMonthly)}</td>
          <td></td>
        </tr></tfoot>
      </table>
    </div>
  );
}

function CostRow({ cost, categories, fmt, onEdit, onDelete }) {
  const cat = categories[cost.category] || categories.other;
  const tags = cost.tags || [];
  return (
    <tr className="hover:bg-gray-50">
      <td className="px-6 py-4"><p className="font-medium text-[#0A1628]">{cost.name}</p>{cost.notes && <p className="text-xs text-gray-400 mt-0.5">{cost.notes}</p>}</td>
      <td className="px-6 py-4"><span className={`px-2 py-1 rounded text-xs font-medium ${cat.color}`}>{cat.label}</span></td>
      <td className="px-6 py-4"><div className="flex flex-wrap gap-1">{tags.length > 0 ? tags.map(t => <CostTag key={t} text={t} />) : <span className="text-xs text-gray-300">-</span>}</div></td>
      <td className="px-6 py-4 text-right font-semibold">{fmt(cost.amount)}</td>
      <td className="px-6 py-4 text-right">
        <button onClick={() => onEdit(cost)} className="p-1.5 text-gray-400 hover:text-[#014DB7]"><Edit className="w-4 h-4" /></button>
        <button onClick={() => onDelete(cost.id)} className="p-1.5 text-gray-400 hover:text-red-500"><Trash2 className="w-4 h-4" /></button>
      </td>
    </tr>
  );
}
